export enum ConstructionKeyType {
  None = 1,
  SplitKey = 2,
  RCKNoMaster = 3,
  RCKTMK = 4,
  RCKChanges = 5,
  BOK = 6,
  WAFERTMK = 7,
  WAFERCHANGES = 8,
}
